import React, { ReactNode, useCallback } from "react";
import styled from "styled-components";

import { useToaster } from "../components/common/Toasts.js";

import { HexToolTipProps, HexTooltip } from "./HexTooltip.js";

export interface HexCopyToClipboardProps extends Pick<
  HexToolTipProps,
  "placement"
> {
  children: ReactNode;
  text?: string | null | (() => string | null);
  stopPropagation?: boolean;
}

export const HexCopyToClipboard: React.ComponentType<HexCopyToClipboardProps> =
  React.memo(function HexCopyToClipboard({
    children,
    placement,
    stopPropagation = false,
    text,
  }) {
    const toaster = useToaster();

    const copyToClipboard = useCallback(
      async (e: React.MouseEvent<HTMLSpanElement>) => {
        if (stopPropagation) {
          e.stopPropagation();
        }

        const clipboardText: string | null =
          typeof text === "function" ? text() : text || null;
        if (clipboardText != null) {
          await navigator.clipboard.writeText(clipboardText).then(() => {
            toaster.show({
              message: "Copied to clipboard!",
              intent: "success",
            });
          });
        }
      },
      [text, toaster, stopPropagation],
    );

    return (
      <HexTooltip
        content="Copy to clipboard"
        disabled={text == null}
        placement={placement}
      >
        <Copyable onClick={copyToClipboard}>{children}</Copyable>
      </HexTooltip>
    );
  });

const Copyable = styled.span`
  cursor: pointer;
`;
